import styled from 'styled-components';

export const TrendingSearchHeading = styled.div`
  padding: 0 18px;
  font-weight: 500;
  font-size: 13px;
  color: hsl(0deg, 0%, 0%, 40%);
  line-height: 56px;
`;
